// import Masonry from "masonry-layout/masonry";


(function( $ ) {

    var grid = document.querySelector('.project__actualities_row');

    imagesLoaded(grid, function () {
        new Masonry(grid, {
            itemSelector: '.project__actuality',
            columnWidth: '.project__actuality-sizer',
            gutter: '.project__actuality-gutter',
            horizontalOrder: true,
            percentPosition: true,
        });
    });

})(jQuery);